<template>
  <div>
    <app-history @clicked="$router.push('/contacts')" />
    <v-card class="form">
      <div class="fullText">
        با سلام خدمت طلبه محترم
        <br />
        <br />
        در اين بخش شما مي توانيد بصورت مستقيم با مسئولان مركز مديريت ارتباط
        برقرار نمائيد. پيام شما (بهمراه نام و مشخصات حضرتعالي) مستقيما به
        كارتابل ايشان ارسال&nbsp; مي گردد
        <br />
        گيرنده پيام خود را مشخص نمائيد و بعد از نوشتن موضوع و پيام خود (و در
        صورت تمايل فايل های لازم)، دكمه ارسال را كليك كنيد.
        <br />
        شما مي توانيد پاسخ خود را در قسمت مشاهده سوابق مشاهده نمائيد. در ضمن
        هنگامي كه نامه شما توسط مدير مربوطه پاسخ داده شد، توسط پيامك به حضرتعالي
        اطلاع رساني خواهد گرديد<br />
        <br />
      </div>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>گیرنده:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-select
            v-model="receiver"
            :items="receivers"
            item-value="receiver.ID"
          >
            <template v-slot:item="{ item }">
              <app-receiver :item="item"></app-receiver>
            </template>
            <template v-slot:selection="{ item }">
              <app-receiver :item="item"></app-receiver>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>موضوع:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-text-field v-model="title"></v-text-field>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <b>پیام:</b>
        </v-col>
        <v-col class="d-flex" cols="12" sm="6">
          <v-textarea outlined v-model="text" no-resize></v-textarea>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col class="d-flex" cols="12" sm="6">
          <v-file-input
            label="ضمائم"
            chips
            v-model="files"
            multiple
          ></v-file-input>
        </v-col>
      </v-row>
      <v-row class="ltr">
        <v-btn
          color="primary white--text"
          class="register"
          rounded
          @click="applyRequest"
          :disabled="apiRunning"
        >
         {{apiRunning ? "لطفا منتظر بمانید..." :  "ثبت"}} 
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { sendMessage } from "@/api/ertebat";
import Receiver from "./Receiver";
import HistoryButton from "@/components/HistoryButton";
export default {
  data() {
    return {
      title: "",
      text: "",
      files: null,
      receiver: null,
    };
  },
  computed: {
    receivers() {
      return this.$store.getters.receivers;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
  },
  components: {
    appReceiver: Receiver,
    appHistory: HistoryButton,
  },
  created() {
    this.$store.dispatch("getReceivers").then(() => {
      this.receiver = this.receivers[0];
    });
  },
  methods: {
    applyRequest() {
      var text = "";
      if (this.title == "") {
        text = " موضوع نباید خالی باشد.";
      } else if (this.text == "") {
        text = "پیام نباید خالی باشد.";
      } else if (this.files != null) {
        var size = 0;
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size;
        }
        if (size > 2000000) {
          text = "مجموع حجم ضمائم نباید بیش از 2 مگابایت باشد.";
        }
      }
      if (text != "") {
        this.$store.commit("SET_SNACKBAR_TEXT", text);

        return;
      } else {
        this.$store.commit("SET_API_RUNNING", true);
        sendMessage(this.files, this.receiver.ID, this.title, this.text)
          .then((response) => {
            const data = response.data;
            this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
            this.$store.commit("SET_API_RUNNING", false);
            if (data.Success) {
              this.goToIndex();
            }
          })
          .catch((error) => {
            this.$store.commit(
              "SET_SNACKBAR_TEXT",
              "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
            );
          });
      }
    },
    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      this.$router.push({ path: "/index" });
    },
  },
};
</script>
<style scoped>
@media only screen and (min-width: 600px) {
  .form {
    width: 570px;
    margin: 15px auto;
  }

  .col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
</style>
